import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { useGroupColumn } from '../../../hooks/useGroupColumn'
import { PayItemConnection } from '../ConnectionsContext'
import { useSourceColumn } from './useSourceColumn'
import { HelpMessage } from 'utils/constants'

export function useColumns(): CIMSColumn<PayItemConnection>[] {
  return [
    useNameColumn({ help: HelpMessage.Name, sort: { default: 'ascend' } }),
    useSourceColumn(),
    useGroupColumn(),
  ]
}
